define('boxes/upload-documents-box',['jquery', 'boxes/box', 'all/comeon', 'boxes/helpers/message-popup','boxes/helpers/box-loading'], function ($, box, comeon, messagePopup,boxLoading) {
    'use strict';

    function hasRequired(uploadDocuments) {
        var isRequired = true;
        var $selectType = uploadDocuments.$box.find('input:checked');

		$selectType.each(function(){
			var textArea = uploadDocuments.$box.find('textarea');
            if($(this).val()==='6' && textArea.val()===''){
				textArea.parent().addClass('has-error');
				isRequired =false;
			}
		});

		if ($selectType.length === 0) {
            uploadDocuments.$box.find('.frame.light').addClass('has-error');
            isRequired = false;
        }

        var $fileInput = uploadDocuments.$box.find('input[type=file]');
        if ($fileInput.val() === '') {
            $fileInput.parent().addClass('has-error');
            isRequired = false;
        }
        return isRequired;
    }

    function setupUIEventHandlers(uploadDocuments) {
        var removeDocumentButtons = uploadDocuments.$box.find('.col.btn.icon');

		function removeDocumentsCallback(e,$removeButton) {
			e.preventDefault();
			$removeButton.off();
			box.ajax(uploadDocuments, {
				url: '/pp?flow=removeUploadedDocument',
				data: {docId: $removeButton.data('documentId')}
			}, function (data) {
				if (data.RESULT === 'OK') {
					$removeButton.closest('.frame-row').remove();
					var $uploadDocumentsDiv = uploadDocuments.$box.find('.uploaded-documents');
					if ($uploadDocumentsDiv.find('div').length < 1) {
						$uploadDocumentsDiv.hide();
					}
					getUploadedDocuments(uploadDocuments).done(function (data) {
						uploadDocuments.model.uploadedDocumentsData = data;
					});
				} else {
					messagePopup.show(uploadDocuments.$box, 'message-popup', {
						title: data.RESPONSE_HEADER,
						message: data.RESPONSE_MESSAGE
					});
				}
			});
		}

		removeDocumentButtons.off('click').on('click', function (e) {
			e.preventDefault();
			var $removeButton = $(this);
			var callbacks = {
				closeButtonCallback: undefined,
				confirmButtonCallback: function(e){
					removeDocumentsCallback(e,$removeButton);
				}
			};
			/*TODO change this message fetching probably requested from the server, hack to get the correct message
			from the html not from the server, maybe we need to change this?
			*/
			var $DocumentsHeader =  uploadDocuments.$box.find('.removeDocumentsHeader').html();
			var $DocumentsMessage =  uploadDocuments.$box.find('.removeDocumentsMessage').html();
			var $DocumentsConfirm =  uploadDocuments.$box.find('.removeDocumentsConfirm').html();
			var messageContent ={
				title: $DocumentsHeader,
				message: $DocumentsMessage,
				confirmButtonText: $DocumentsConfirm
			};
			messagePopup.show(uploadDocuments.$box, 'message-popup',messageContent,callbacks);
		});

        uploadDocuments.$box.find('input[type=file]').off().on('change', function(event) {
            uploadDocuments.model.files = event.target.files;
            $(event.target).closest('.form-group').removeClass('has-error');
        });

        uploadDocuments.$box.find('').off().on('change', function(event) {
            $(event.target).closest('.frame.light').removeClass('has-error');
        });

        var $backButton = uploadDocuments.$box.find('.ui-button.color-secondary');
        $backButton.off().on('click', function (e) {
			// the next time that a user clicks on the back button, she must routes to the withdraw from and NOT the start page!
            $(this).off().on('click', function(e) {
				e.preventDefault();
			});
            e.preventDefault();
            uploadDocuments.$controller.previousBox();
        });

        var $uploadButton = uploadDocuments.$box.find('.ui-button.color-primary');
        $uploadButton.off('click').on('click', function (e) {
            e.preventDefault();
            if (hasRequired(uploadDocuments) === false) {
                return;
            }
            var data = new FormData();
            $.each(uploadDocuments.model.files, function(key, value) {
                data.append(key, value);
            });
            uploadDocuments.$box.find('input:checked').each(function() {
                data.append('type',$(this).val());
            });

            data.append('other-reason', uploadDocuments.$box.find('textarea').val());

			boxLoading.showLoading(uploadDocuments.$box);
            $.ajax({
                url: '/pp?flow=UploadDocFromHtml',
                type: 'POST',
                data: data,
                cache: false,
                dataType: 'json',
                processData: false,
                contentType: false,
                success: function(response) {
					boxLoading.removeLoading(uploadDocuments.$box);
					if(!response.error){
						uploadDocuments.$box.find('input:not([type="checkbox"])').val('');
						uploadDocuments.$box.find('select').val('0');
						uploadDocuments.$box.find('textarea').val('');
						unCheckAllTypes(uploadDocuments);
                        getUploadedDocuments(uploadDocuments).done(function(data) {
                            uploadDocuments.model.uploadedDocumentsData = data;
                            uploadDocuments.model.beforeRender(uploadDocuments);
                            uploadDocuments.view.render(uploadDocuments);
                            uploadDocuments.model.afterRender(uploadDocuments);
                        });
                    }else{
                        showUploadFailMessage(uploadDocuments,{message: response.message});
                    }
					uploadDocuments.$box.find('.frame.light').removeClass('has-error');
                }
            });
        });
    }

    function unCheckAllTypes(uploadBox){
        uploadBox.$box.find('input:checked').each(function(){$(this).attr('checked', false);});
    }

    function showUploadFailMessage(uploadBox, failMessage){
        messagePopup.show(uploadBox.$box, 'message-popup', failMessage);
    }

    function getUploadedDocuments() {
        return $.ajax({
            url: '/pp?flow=GetUploadedDocumentsJson'
        });
    }

	function resetComment(uploadDocuments){
		uploadDocuments.$box.find('textarea').focusout(function(){
			if($(this).val()!==''){
				$(this).parent().removeClass('has-error');
			}
		});


	}


    var view = {
            render: function (uploadDocuments) {
                var mustacheTemplateId = 'uploaded-documents-template',
                    $uploadDocumentsDiv = uploadDocuments.$box.find('.uploaded-documents');

                $.Mustache.addFromDom(mustacheTemplateId);
                $uploadDocumentsDiv.children().remove();
                if (uploadDocuments.model.uploadedDocumentsData.length < 1) {
                    $uploadDocumentsDiv.hide();
                    return;
                }
                $uploadDocumentsDiv.show();
                $uploadDocumentsDiv.mustache(mustacheTemplateId, {
                    uploadDocuments: uploadDocuments.model.uploadedDocumentsData
                }, {
                    method: 'html'
                });
            }
        },
        model = {
            uploadedDocumentsData: [],
            files: {},
            shouldShowBox: false,
            init: function (uploadDocuments) {
                getUploadedDocuments(uploadDocuments).done(function(data) {
                        uploadDocuments.model.uploadedDocumentsData = data;
                });

                uploadDocuments.model.showPromise = comeon.promise.create();
                uploadDocuments.$controller.on('uploadEvent', function() {
                    uploadDocuments.model.shouldShowBox = true;
                });
                uploadDocuments.$controller.on('skipEvent', function() {
                    uploadDocuments.model.shouldShowBox = false;
                });
				resetComment(uploadDocuments);
            },
            beforeRender: function (uploadDocuments) {
                uploadDocuments.model.files = {};

                var showPromise = comeon.promise.create();
                if (uploadDocuments.model.shouldShowBox) {
                    showPromise.resolve();
                } else {
                    showPromise.reject();
                }

                return [showPromise.promise()];
            },
            afterRender: function (uploadDocuments) {
                setupUIEventHandlers(uploadDocuments);
                unCheckAllTypes(uploadDocuments);
            }
        };

    return {
        create: function ($box, $controller) {
            return box.create($box, $controller, view, model);
        }
    };
});

